import React from "react";
import QuestionListCreator from "../Components/CreateQuestionsList/QuestionListCreator";

const QuestionListPage: React.FC = () => {
  return <QuestionListCreator />;
};

export default QuestionListPage;
